import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import AuthenticatedMenuBar from './AuthenticatedMenuBar';
import RemoteFFHeader from './RemoteFFHeader';
import { FF_HEADER_SCRIPT_URL } from '~/app/settings';
import PATHS from '~/app/utils/paths';

/**
 * Map route locale to FFHeader region.
 * API documents 'us' | 'cn'; AE and others fall back to 'us'.
 *
 * @param {string} [locale]
 * @returns {'us' | 'cn'}
 */
export function mapLocaleToRegion(locale) {
  if (locale === 'cn') {
    return 'cn';
  }
  return 'us';
}

/**
 * FX preorder pages keep the legacy header (custom FX logo / float styling).
 *
 * @param {string} pathname
 * @param {string} [locale]
 * @returns {boolean}
 */
export function isFXPreorderPath(pathname, locale) {
  if (!pathname || !locale) {
    return false;
  }

  return (
    pathname === `/${locale}${PATHS.RESERVE}${PATHS.FX_SIMPLE_PREORDER}` ||
    pathname === `/${locale}${PATHS.RESERVE}${PATHS.FX_SIMPLE_PREORDER_SUPER_ONE}` ||
    pathname === `/${locale}${PATHS.APP_FX_SIMPLE_PREORDER}` ||
    pathname === `/${locale}${PATHS.RESERVE}${PATHS.FX_EARLY_ACCESS_PREORDER}` ||
    pathname === `/${locale}${PATHS.APP_FX_EARLY_ACCESS_PREORDER}` ||
    pathname === `/${locale}/advanceorder/fx` ||
    pathname === `/${locale}/h5/advanceorder/fx`
  );
}

/**
 * Shared header entry: remote CDN FFHeader when REACT_APP_FF_HEADER_SCRIPT_URL
 * is set, otherwise the legacy AuthenticatedMenuBar.
 * FX preorder pages always use the legacy header.
 */
export default function AppMenuBar(menuProps) {
  const params = useParams();
  const location = useLocation();
  const locale = params?.locale;
  const useRemoteHeader = Boolean(FF_HEADER_SCRIPT_URL)
    && !isFXPreorderPath(location.pathname, locale);

  if (useRemoteHeader) {
    return (
      <RemoteFFHeader
        region={mapLocaleToRegion(locale)}
        props={menuProps}
        scriptUrl={FF_HEADER_SCRIPT_URL}
      />
    );
  }

  return <AuthenticatedMenuBar {...menuProps} />;
}
